<ng-container *ngIf="isShowNewPayment">
  <div class="marine-insurance-application-recalculate-new-output">
    <div
      class="marine-insurance-application-recalculate-new-output-back"
      [ngClass]="{ 'marine-insurance-application-recalculate-new-output-back-disabled': isPaymentMade }"
      (click)="onDiscard()"
    >
      <img src="/assets/icons/icon_arrow_left_sm_gray.svg" />
      {{ "BUTTON.BACK" | translate }}
    </div>

    <app-marine-insurance-quote-view-data
      [marineInsurance]="marineInsurance"
      [isShowUpdatedInsuredValue]="true"
      [isShowUpdatedDate]="true"
      [isShowCertificate]="false"
    ></app-marine-insurance-quote-view-data>

    <div class="marine-insurance-application-recalculate-new-output-separator"></div>

    <div class="marine-insurance-application-recalculate-new-output-payment">
      <div class="marine-insurance-application-recalculate-new-output-payment-header">{{ "LABELS.PAYMENT_BREAKDOWN" | translate }}</div>

      <div class="marine-insurance-application-recalculate-new-output-payment-item" *ngFor="let item of joinedItems">
        <div class="marine-insurance-application-recalculate-new-output-payment-item-label">
          {{ item.description }}
        </div>
        <div class="marine-insurance-application-recalculate-new-output-payment-item-value">
          {{ item.price | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}
        </div>
      </div>

      <div class="marine-insurance-application-recalculate-new-output-payment-footer">
        <div class="marine-insurance-application-recalculate-new-output-payment-footer-label">{{ "LABELS.TOTAL_PAYMENT" | translate }}</div>
        <div class="marine-insurance-application-recalculate-new-output-payment-footer-value">
          <div class="marine-insurance-application-recalculate-new-output-payment-footer-value-prev">
            ({{ "LABELS.PAID" | translate }} {{ totalPrevSum | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }})
          </div>
          <div
            class="marine-insurance-application-recalculate-new-output-payment-footer-value-curr"
            [ngClass]="{
              'marine-insurance-application-recalculate-new-output-payment-footer-value-curr-refund': totalDiffSum < 0
            }"
          >
            {{ totalCurrSum | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}
          </div>
        </div>
      </div>

      <div class="marine-insurance-application-recalculate-new-output-footer">
        <button
          type="button"
          class="marine-insurance-application-recalculate-new-output-footer-btn-discard"
          [disabled]="isPaymentMade"
          (click)="onDiscard()"
        >
          {{ "DISCARD" | translate }}
        </button>

        <button
          type="button"
          class="marine-insurance-application-recalculate-new-output-footer-btn-submit"
          [ngClass]="{
            'marine-insurance-application-recalculate-new-output-footer-btn-submit-additional': totalDiffSum >= 0,
            'marine-insurance-application-recalculate-new-output-footer-btn-submit-refund': totalDiffSum < 0
          }"
          [disabled]="isPaymentApplied || isSaving"
          (click)="onSave()"
        >
          {{ saveText | translate }}
          <span *ngIf="totalDiffSum !== 0">({{ totalDiffSum | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }})</span>
        </button>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!isShowNewPayment">
  <h3 class="marine-insurance-application-recalculate-note-action">{{ "PLEASE_FILL_INFORMATION" | translate }}</h3>

  <section>
    <div class="marine-insurance-application-recalculate-col-value">
      <app-control-wrapper
        [control]="formGroup.get('insuredAmount')"
        [errors]="errors.insuredAmount"
        [errorsOverrideParams]="{ max: { limit: insuredAmountLimit | currency : DEFAULT_CURRENCY_CODE : 'symbol' : '1.2-2' } }"
      >
        <label for="insuredAmount" control-label>{{ "INSURED_VALUE" | translate }}</label>
        <div class="d-flex" control-wrapper>
          <input
            id="insuredAmount"
            class="form-control"
            type="text"
            inputmode="numeric"
            [pattern]="currencyInputMap.pattern"
            [mask]="currencyInputMap.mask"
            [thousandSeparator]="currencyInputMap.thousandSeparator"
            [appMaskErrorTooltip]="currencyInputMap.maskErrorTooltip"
            [formControl]="formGroup.get('insuredAmount')"
          />
          <div class="form-control currency">USD</div>
        </div>
      </app-control-wrapper>
    </div>

    <p class="marine-insurance-application-recalculate-add-cif">
      {{ "MARINE_INSURANCE_ADD_CIF" | translate }}
      <button class="marine-insurance-application-recalculate-add-cif-btn" [disabled]="cifAdded" (click)="addCif()">
        {{ "BUTTON.ADD" | translate }}+{{ cifPercentage }}%
      </button>
    </p>

    <p class="marine-insurance-application-recalculate-categories-header">{{ "COMMODITIES_CATEGORY" | translate }}</p>

    <div
      class="marine-insurance-application-recalculate-categories-item"
      [ngClass]="{ 'is-selected': formGroup.get('commodityId').value === commodity.id }"
      *ngFor="let commodity of commodities"
    >
      <div class="marine-insurance-application-recalculate-categories-item-header">
        <app-radio-button
          [control]="formGroup.get('commodityId')"
          [id]="'commodity-' + commodity.id"
          [label]="commodity.name"
          [value]="commodity.id"
          [name]="'commodity-id'"
        ></app-radio-button>
      </div>
      <div
        class="marine-insurance-application-recalculate-categories-item-body"
        *ngIf="formGroup.get('commodityId').value === commodity.id"
      >
        <p
          class="marine-insurance-application-recalculate-categories-item-body-description"
          [innerHTML]="getCommodityDescription(commodity.id) | translate"
          [ngClass]="{ 'is-opened': isOpenedDescription }"
        ></p>

        <div
          class="marine-insurance-application-recalculate-categories-item-body-transportation"
          *ngIf="isShowTransportationMode(commodity.id)"
        >
          <p class="marine-insurance-application-recalculate-categories-item-body-transportation-header">
            {{ "PLEASE_CHOOSE_RELEVANT_TRANSPORTING_METHOD" | translate }}
          </p>

          <div class="marine-insurance-application-recalculate-categories-item-body-transportation-items">
            <app-radio-button
              [control]="formGroup.get('typeOfShipment')"
              [id]="'typeOfShipment-breakbulk'"
              [label]="'NON_CONTAINERIZED'"
              [value]="enumInsuranceShipmentType.BREAKBULK"
              [name]="'typeOfShipment'"
            ></app-radio-button>

            <app-radio-button
              [control]="formGroup.get('typeOfShipment')"
              [id]="'typeOfShipment-fca'"
              [label]="'CONTAINERIZED'"
              [value]="enumInsuranceShipmentType.FULL_CONTAINER"
              [name]="'typeOfShipment'"
            ></app-radio-button>
          </div>
        </div>

        <div
          class="marine-insurance-application-recalculate-categories-item-body-see-more"
          *ngIf="isShowMore(commodity.id)"
          (click)="setOpenedDescription()"
        >
          {{ (isOpenedDescription ? "BUTTON.CLOSE" : "BUTTON.SEE_MORE") | translate }}
          <div
            class="marine-insurance-application-recalculate-categories-item-body-see-more-icon"
            [ngClass]="{ 'is-opened': isOpenedDescription }"
          >
            <img src="assets/icons/icon_chevron_down_sm.svg" />
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="marine-insurance-application-recalculate-footer">
    <button type="submit" class="btn btn-primary" [disabled]="isSaving" (click)="onRecalculate()">
      {{ "RECALCULATE" | translate }}
    </button>
  </section>
</ng-container>

<loading-spinner [show]="isSaving"></loading-spinner>
